// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Minicart__footer__root","root_open":"cmp-Minicart__footer__root_open cmp-Minicart__footer__root","placeholderButton":"cmp-Minicart__footer__placeholderButton"};